<template>
    <template v-if="loading">
      <section class="w-full h-full min-h-60 border shimmer">
  
      </section>
    </template>
    <template v-else>
      <section class="w-full min-h-60 ">
        <swiper
          :slidesPerView="1"
          :spaceBetween="4"
          :lazy="true"
          :pagination="{ clickable: true, el: '.custom-pagination' }"
          :navigation="false"
          :modules="modules"
            class="mySwiper h-72 w-full">
          <swiper-slide v-for="(item,index) in items" :key="index" class="w-full h-full flex-center">
              <div class="w-48 aspect-[2/3] " >
                 <img   v-lazy="{ src:'https://parsinekala.com' +item, loading: require('@/assets/images/loadImage1.png'), error: require('@/assets/images/loadImage2.png') }" class=" w-full h-full" alt="product image" aria-label="product image" />
              </div>
          </swiper-slide>

          <!-- Custom pagination element -->
          <div class="custom-pagination"></div>
         </swiper>
        
     </section>
    </template>
</template>
<script setup>
import {ref,defineProps, watch, onMounted} from 'vue';
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation } from 'swiper';
// Import only the CSS styles you need dynamically
  import("swiper/css").then(() => {
  import("swiper/css/navigation");
  import("swiper/css/pagination");
  import("swiper/css/scrollbar");
});
const modules=[ Pagination, Navigation]
const loading=ref(true);

const props=defineProps({
  pictures:{type:Array}
})
   watch(props.pictures,()=>{
    setItem()
    
 
})
onMounted(()=>{
  setItem()
})
const items=ref([])
const setItem=()=>{
    props.pictures.forEach((e)=>{
      items.value.push(e)
    })
    if(items.value.length){
      loading.value=false;
    }
}



</script>

<style scoped>
/* Style the custom pagination to be on the left */
.custom-pagination {
  position: absolute;
  top: 90%;
  right: 80%;
  display: flex;
  gap: 2px;

}

.custom-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #ccc;
  border-radius: 50%;
  opacity: 1;
  transition: background-color 0.3s ease;
}


</style>
